module.exports = __webpack_public_path__ + "static/capo-profile-img-2dfe2c14fa90c7c6497a4b6d35165f82.png";